import { Box, Stack, Typography } from "@mui/material"
import { useParams } from "react-router"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { TaskListRefresh } from "event-definitions"
import { TaskRowEnd, TaskRowAfterEntry, TaskRowAfter, UOMArea } from "slot-definitions"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { AuthoringTaskRowEndActions } from "./authoring-task-actions"
import { AuthoringTaskListDisplay } from "./authoring-task-list-display"
import { frag } from "lib/@components/slot/frag"
import { AmendsBoundaryTaskEditor } from "authoring/routes/project/amends/components/amends-boundary-task-editor"
import { Bound } from "lib/@components/binding/Bound"
import { getTaskAmendsKey } from "authoring/routes/project/amends/lib/task-amends-key"
import { AuthoringTaskRejectionEntry } from "./authoring-task-rejection-entry"
import { AuthoringEditorRejectionBanner } from "./authoring-editor-rejection-banner"
import { MOVEMENTS_AMENDS_KEY } from "authoring/routes/project/amends/lib/constants/amends-keys"
import { AmendsBoundaryButton } from "authoring/routes/project/amends/components/amends-boundary-button"
import { AmendsBoundaryEditor } from "authoring/routes/project/amends/components/amends-boundary-editor"
import { useAmendCollapse } from "authoring/routes/project/amends/components/use-amend-collapse"
import { createDraftId } from "authoring/routes/project/lib/project-utils"

export function ScheduleEditorTasks() {
    const { target } = useBoundContext()
    const tasks = target?.tasks ?? []
    const { projectId, scheduleId } = useParams()
    const draftId = createDraftId(projectId, scheduleId)
    const { isCollapsed: movementsCollapsed, onToggleCollapsed: toggleMovements } = useAmendCollapse(draftId)

    TaskListRefresh.useRefresh()
    UOMArea.usePlug(replaceAllWith(frag))
    TaskRowEnd.usePlug(replaceAllWith(<AuthoringTaskRowEndActions />))
    TaskRowAfterEntry.usePlug(replaceAllWith(frag))
    TaskRowAfter.usePlug(<AmendsBoundaryTaskEditor />)
    TaskRowAfter.usePlug(<AuthoringTaskRejectionEntry />)

    return (
        <Box mt={3}>
            <Bound getTaskAmendsKey={getTaskAmendsKey}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Typography variant="h6">Tasks</Typography>
                    <Stack direction="row" alignItems="center" spacing={0.5} data-cy="task-order-amends-row">
                        <Typography variant="caption" color="text.secondary">
                            Task Order
                        </Typography>
                        <AmendsBoundaryButton amendsKey={MOVEMENTS_AMENDS_KEY} />
                    </Stack>
                </Stack>
                <AmendsBoundaryEditor
                    amendsKey={MOVEMENTS_AMENDS_KEY}
                    subtitle="Change Task Order Reason"
                    data-cy="task-order-amends"
                    collapsible
                    isCollapsed={movementsCollapsed}
                    onToggleCollapsed={toggleMovements}
                />
                <AuthoringEditorRejectionBanner amendsKey={MOVEMENTS_AMENDS_KEY} />
                <AuthoringTaskListDisplay tasks={tasks} schedule={target} />
            </Bound>
        </Box>
    )
}
